 // import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
// import { Router } from '@angular/router';
// import { apiUrlComponent } from '../common/api.url.component';
// import { ApiService } from '../common/API/api.service';
// import { StorageService } from './service.StorageService';
// import { User } from '../Models/USermodel';
// import { Observable } from 'rxjs';
// import { promise } from 'protractor';
//declare var config;
// @Injectable({ providedIn: "root" })
// export class AuthService {
// private isauth= false;
//     constructor(private client: HttpClient, private router: Router,private apiUrl: apiUrlComponent, private storage: StorageService,private _apiService: ApiService) {
//     }
//     login({...user}: User, cb: Function)
//     {
//         debugger;
//         var login={
//             EmployeeCode:user.username,
//             Password:user.password
//         }
//         return this._apiService.post(config.urlpath + 'api/login',login).subscribe(result => {
//             debugger;
//             if (result.Success === true) {            
//                 cb(null,true,result.Data);
//             } else {
//                 cb(null,false);
//             }
//           },
//             error => {
//               console.log(error);
//               cb(error,null);
//             }
//           );
//         }
//     logout() {      
//         this.storage.clear();
//         this.router.navigate(['/']);
//     }
// }


import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class AlwaysAuthGuard implements CanActivate {
  constructor(private Router: Router) { }
  canActivate() {
    const _isUser =sessionStorage.getItem('user');
    console.log(_isUser);
    if (_isUser === null || _isUser === undefined || _isUser === '') {
      this.Router.navigateByUrl('/');
    } else {
      return true;
    }
    return true;
  }
  
}
